/* eslint-disable react/no-unused-state */
import { Hidden } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import * as moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { templateStrings } from "../../../Constant";
import { dateDueBreakDownAction } from "../../../redux/action-creators/dateDueBreakDownActionCreator";
import { PageWrapper, TableWrapper } from "../../../shared/layout";
import { getSettlementTemplateString } from "../../../shared/methods/sharedMethods";
import { ExportButton } from "../../../shared/widgets";
import { SearchBar } from "../../../shared/widgets/searchView/searchComponent";

const styles = {
  tableHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginLeft: "10px",
  },
  exportBtn: {
    marginRight: "10px",
  },
};

class DateDueWiseList extends React.Component {
  constructor(props) {
    super(props);
    const m = moment(new Date());
    this.state = {
      pageNo: 0,
      date: m,
      rowsPerPage: 10,
      selected: [],
      searchString: "",
    };
    this.getList = this.getList.bind(this);
    this.handleAction = this.handleAction.bind(this);
  }

  componentDidMount() {
    this.getList();
  }

  componentDidUpdate(prevProps, prevState) {
    const { searchString } = this.state;
    if (prevState && prevState.searchString !== searchString) {
      this.getList();
    }
  }

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.setState({ selected: [] });
        this.getList();
      }
    });
  };

  // eslint-disable-next-line class-methods-use-this
  handleAction() {
    // eslint-disable-next-line no-console
    console.log("action clicked");
  }

  handleSearchChange(e) {
    this.setState({ searchString: e });
  }

  /**
   * API call to get data.
   * @param pageNo current page number
   */
  getList() {
    const {
      fetchDateDueBreakDown, operatorId, cityId, fromDate, dueId,
    } = this.props;
    const { pageNo, rowsPerPage, searchString } = this.state;
    fetchDateDueBreakDown({
      pageNo,
      pageSize: rowsPerPage,
      operatorId,
      cityId,
      fromDate,
      dueId,
      search: searchString,
    });
  }

  render() {
    const {
      headerLoader, gridLoader, config, content, totalItem, classes, dueId,
      refreshUpliftStatus, showPgFee,
    } = this.props;
    const { selected, pageNo, rowsPerPage } = this.state;
    const gridStrings = config
  && getSettlementTemplateString(
    config,
    showPgFee
      ? Object.fromEntries(
        Object.entries(templateStrings.dateDetailDayWise).filter(
          ([key]) => key !== "walletUsage",
        ),
      )
      : Object.fromEntries(
        Object.entries(templateStrings.dateDetailDayWise).filter(
          ([key]) => !["pgFee", "cardDigitalCollection", "mobileDigitalCollection"].includes(key),
        ),
      ),
  );

    const endpoint = "settlementsPage/exportDueBreakdown";
    const exportBuswiseBreakdown = {
      addOnFilter: {
        dueId,
      },
      timeZoneOffset: 330,
    };

    return (
      <div>
        <PageWrapper.Header
          customClass="row-header"
          heading="Buswise Breakdown"
          hideS
          isHeaderFixed={false}
          removeFilterOnly
          hideDivider
        >
          <Hidden only={["lg", "xl", "md"]}>
            <div className="tabWrapper">
              <SearchBar
                placeHolder="Search for Bus number"
                onSearchChange={(e) => {
                  this.handleSearchChange(e);
                }}
              />
            </div>
          </Hidden>
          <Hidden only={["sm", "xs"]}>
            <div className="pull-right search-container">
              <SearchBar
                placeHolder="Search for Bus number"
                onSearchChange={(e) => {
                  this.handleSearchChange(e);
                }}
              />
            </div>
          </Hidden>
          <div className={classes.tableHeader}>
            <ExportButton
              query={exportBuswiseBreakdown}
              endpoint={endpoint}
              pageName="Settlement"
              isDisable={
                refreshUpliftStatus === "Data Sync In Process"
              }
            />
          </div>
        </PageWrapper.Header>
        <PageWrapper.Body style={{ marginTop: 0 }}>
          <TableWrapper
            content={!headerLoader && content}
            selected={selected}
            pageNo={pageNo}
            uniqueKey="uniqueKey"
            rowsPerPage={rowsPerPage}
            count={totalItem}
            handleChange={this.handleChange}
            templateString={gridStrings || {}}
            minWidth={200}
            handleAction={this.handleAction}
            gridLoader={gridLoader}
            tableContainerClassName="day-wise-dues-breakdown"
          />
        </PageWrapper.Body>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content: state.DateDue?.dateDueBreakDown?.items || [],
    config: state.DateDue?.dateDueBreakDown?.calculationConfig,
    totalItem: state.DateDue?.dateDueBreakDown?.totalItems || 0,
    selectedDateFilter: state.DateFilter?.selectedDateFilter,
    headerLoader: state && state.loadingBar && state.loadingBar.header,
    gridLoader: state && state.loadingBar && state.loadingBar.gridLoader,
    showPgFee: state?.DateDue?.dateDueBreakDown?.showPgFee,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchDateDueBreakDown: (params) => {
    dispatch(dateDueBreakDownAction(params));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(DateDueWiseList));
